import * as React from 'react';
import { SVGProps } from 'react';

const IconSelectSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.5 5 8 10l4.5-5h-9z" />
  </svg>
);

export default IconSelectSizeS;
